import { render } from "./completedvisits.vue?vue&type=template&id=775754ca"
import script from "./completedvisits.vue?vue&type=script&lang=js"
export * from "./completedvisits.vue?vue&type=script&lang=js"

import "./completedvisits.vue?vue&type=style&index=0&id=775754ca&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__